import { render } from "./KingdomUnionSuccess.vue?vue&type=template&id=3fc0b234"
import script from "./KingdomUnionSuccess.vue?vue&type=script&lang=js"
export * from "./KingdomUnionSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingdomUnionSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fc0b234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fc0b234', __exports__)) {
    api.reload('3fc0b234', __exports__)
  }
  
  module.hot.accept("./KingdomUnionSuccess.vue?vue&type=template&id=3fc0b234", () => {
    api.rerender('3fc0b234', render)
  })

}


export default __exports__